import { ToggleSwitch } from './ToggleSwitch';
import { DualToggleSwitch } from './DualToggleSwitch';

export { ToggleSwitch };

export default DualToggleSwitch;
